import { render, staticRenderFns } from "./AgentDetails.vue?vue&type=template&id=246fd556&scoped=true&"
import script from "./AgentDetails.vue?vue&type=script&lang=js&"
export * from "./AgentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AgentDetails.vue?vue&type=style&index=0&id=246fd556&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246fd556",
  null
  
)

export default component.exports